/* TAVERA warm-modern micro-interactions: progressive enhancement; no tracking */
(function () {
  function begin() {
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var targets = document.querySelectorAll('.tv-launch-panel .tv-launch-section-head, .tv-launch-panel .tv-launch-features, .tv-launch-panel .tv-launch-packs, .tv-launch-panel .tv-launch-full-image, .tv-launch-panel .tv-info-layout, .tv-launch-panel .tv-steps, .tv-launch-panel .tv-value-grid, .tv-launch-panel .tv-customer-grid, .tv-home-feedback-row');
    if (!targets.length) return;
    targets.forEach(function (node) { node.classList.add('tv-motion-target'); });
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) { if (entry.isIntersecting) { entry.target.classList.add('tv-visible'); observer.unobserve(entry.target); } });
    }, { threshold: 0.06, rootMargin: '0px 0px 10px 0px' });
    targets.forEach(function(node){ if(node.getBoundingClientRect().top < window.innerHeight * 0.94) node.classList.add('tv-visible'); observer.observe(node); });
    document.body.classList.add('tv-motion-ready');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', begin); else begin();
})();
